import React from "react";
import { Card, CardContent } from "./ui/card";
import { Users, Heart, Star, Award } from "lucide-react";

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Heart,
      title: "Building Lasting Relationships",
      description: "We don't just provide valet services - we strive to build genuine bonds with our customers. Understanding your preferences helps us deliver personalized, exceptional service every time.",
      color: "from-yellow-50 to-amber-50",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-700"
    },
    {
      icon: Users,
      title: "Customer-Centric Approach",
      description: "Your satisfaction drives everything we do. We take time to understand your unique needs and preferences to create a tailored experience that exceeds expectations.",
      color: "from-amber-50 to-yellow-50",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-700"
    },
    {
      icon: Star,
      title: "Professional Excellence",
      description: "Our team of experienced drivers maintains the highest standards of professionalism, ensuring safe, reliable, and courteous service for every journey.",
      color: "from-yellow-50 to-white",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-700"
    },
    {
      icon: Award,
      title: "Trusted & Reliable",
      description: "With our commitment to safety, punctuality, and quality service, we've earned the trust of countless customers who rely on us for their transportation needs.",
      color: "from-white to-yellow-50",
      iconBg: "bg-amber-100",
      iconColor: "text-amber-700"
    }
  ];

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Why Choose Valet Find Me?
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            More than just a ride - we're your trusted partner for safe, reliable transportation
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <Card
                key={index}
                className={`border-2 border-yellow-200 shadow-lg hover:shadow-2xl transition-shadow overflow-hidden card-hover bg-gradient-to-br ${reason.color}`}
              >
                <CardContent className="p-8">
                  <div className={`w-16 h-16 ${reason.iconBg} rounded-xl flex items-center justify-center mb-6`}>
                    <Icon className={`w-8 h-8 ${reason.iconColor}`} />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900 mb-4">
                    {reason.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed text-lg">
                    {reason.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA Section */}
        <div className="mt-16 bg-gradient-to-r from-yellow-400 to-amber-400 rounded-2xl shadow-2xl p-12 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Experience The Difference
          </h3>
          <p className="text-xl text-slate-800 max-w-2xl mx-auto">
            Join our growing family of satisfied customers who trust us for safe, professional valet services.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
